export enum Colors {
  primary = 'green',
  secondary = 'gray',
  transparent = 'transparent',
  black = 'black',
  rounded = 'rounded',
}
